/**
 * Created by vladislav on 1/18/2024
 */

const GDComLogic = function () {
    PlatformLogic.call(this);

    if (GDComLogic.LANGUAGE_LOCKED_GAMES.includes(cleverapps.config.name) && GDComLogic.isLanguageLockedDomain()) {
        cleverapps.config.languages = [connector.LANGUAGE_ENGLISH];
    }
};

GDComLogic.prototype = Object.create(PlatformLogic.prototype);
GDComLogic.prototype.constructor = GDComLogic;

GDComLogic.LANGUAGE_LOCKED_DOMAINS = [
    "production.d3u8b3f4e67fsb.amplifyapp.com",
    "games.arabic.cnn.com"
];

GDComLogic.LANGUAGE_LOCKED_GAMES = ["riddles", "mergecraft", "woodenblock"];

GDComLogic.isLanguageLockedDomain = function () {
    let parentHref;
    try {
        parentHref = window.parent.location.href;
    } catch (e) {
        parentHref = document.referrer;
    }

    return [window.location.href, parentHref].some((url) => url
        && GDComLogic.LANGUAGE_LOCKED_DOMAINS.some((domain) => url.includes(domain)));
};

GDComLogic.prototype.loadOldUserId = function (callback) {
    const prefix = cleverapps.config.name + connector.platform.getLocalStoragePrefix();

    cleverapps.getFrameData(cleverapps.config.staticUrl, {
        prefix,
        callback: (data) => {
            if (!data) {
                cleverapps.metrics.logEvent(`${cleverapps.EVENTS.DEBUG.OLD_USER_LOAD}error`);
            }

            data = data && data[prefix];
            let user = {};

            try {
                user = data && JSON.parse(data) || {};
            } catch (e) {
                console.error("parse frameUserId error", e);
            }

            callback(user.id, user);
        }
    });
};
